import {Link} from 'react-router-dom';
import {ArrowLeft} from 'lucide-react';
import {StaticPage} from '@client/pages/public/enroll/components/StaticPage';
import {POSTHOG_UNMASK_CLASS} from '@common-web/lib/analytics';
import {useEnrollGroup} from '@client/pages/public/enroll/enrollContext';
import {DocCard} from '@client/pages/public/enroll/pages/EnrollResources';
import {HighlightAndDisclosures} from '@client/pages/public/enroll/components/HighlightAndDisclosures';

export function EnrollNotices() {
  const group = useEnrollGroup();
  const content = group.resourcesHidden ? undefined : group.noticesPage;
  const title = content?.title || 'Annual Notices';

  if (!content?.documents.length) {
    return (
      <StaticPage eyebrow={group.name} title={title}>
        Annual notices for this group aren't posted online yet — contact your{' '}
        {group.benefitsContact ?? 'HR office'} or the Concierge Team at {group.supportPhone}.
      </StaticPage>
    );
  }

  return (
    <div className={`mx-auto max-w-7xl space-y-8 ${POSTHOG_UNMASK_CLASS}`}>
      <Link
        to={`/${group.slug}`}
        className='inline-flex items-center gap-1.5 text-sm font-medium text-neutral-500 transition-colors hover:text-[var(--enroll-primary)]'
      >
        <ArrowLeft className='h-4 w-4' />
        Back to home
      </Link>

      <header className='space-y-3'>
        <h1 className='text-4xl font-bold tracking-tight text-[var(--enroll-ink)]'>{title}</h1>
        {content.intro && <p className='text-neutral-500'>{content.intro}</p>}
      </header>

      <div className='grid gap-4 sm:grid-cols-2 lg:grid-cols-3'>
        {content.documents.map((doc, i) => (
          <DocCard key={i} doc={doc} />
        ))}
      </div>

      <HighlightAndDisclosures highlight={content.highlight} disclosures={content.disclosures} />
    </div>
  );
}
